// @styles
require('./aggregatorCredentialsPSD2Styles.scss')

// @vendors
import React, { Component } from 'react';
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';
import getBreadCrumbSettings from 'utilities/aggregator/getRenewTokenBreadCrumbSettings';

// @constants
import { STEP } from 'constants/aggregator/consentViewType';
import { RENEW_TOKEN } from 'constants/aggregator/psd2DecoupledFlowType';
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';

// @constants
const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR_ENTITY_SUCCESS,
    PROC_ADD_ENTITY,
    PROC_AGGREGATOR,
    PROC_SUCCESS_CREATE_CONSENT
} = require('utilities/tagging');

class AggregatorRenewCredentialsPSD2Ok extends Component {

    constructor() {
        super();
        const { bankName, bankLogo } = Storage.localStorage.get(SELECTED_BANK) || {};
        const psd2FlowType = Storage.localStorage.get(PSD2_FLOW_TYPE)
        this.state = { bankName, bankLogo, isRenewTokenFlow: psd2FlowType === RENEW_TOKEN }
        this.handleGoToGlobalPosition = this.handleGoToGlobalPosition.bind(this);
        this.handleGoToCreateConsent = this.handleGoToCreateConsent.bind(this);
    }

    componentDidMount() {
        recordPath(PROC_AGGREGATOR_ENTITY_SUCCESS,null,PROC_ADD_ENTITY,PROC_SUCCESS_CREATE_CONSENT);
    }

    handleGoToGlobalPosition = () => {
        recordLink(PROC_AGGREGATOR, PROC_SUCCESS_CREATE_CONSENT)
        this.props.history.push('/myprofile/global')
    }

    handleGoToCreateConsent = () => this.props.history.push(`/myprofile/global/entities/consent/${STEP}`)

    getContinueButton = isRenewTokenFlow => isRenewTokenFlow ?
        <OKButton onClick={this.handleGoToGlobalPosition} modifier="link-complementary">
            <FormattedText value="aggregatorPSD2-credentialsKoBackGlobalPositionButton" />
        </OKButton> :
        <OKButton onClick={this.handleGoToCreateConsent}>
            <FormattedText value="aggregatorPSD2-credentialsOkButtonText" />
        </OKButton>

    render() {
        const { bankName, bankLogo, isRenewTokenFlow } = this.state;

        return (
            <AggregatorAddEntityLayout
                title={formatText('aggregatorAddEntity-renewSessionLayoutTitle')}
                breadCrumb={getBreadCrumbSettings()}
            >
                <OKSectionBox className="aggregator-psd2-credentials col-md-8" title={formatText('aggregatorPSD2-credentialsOkTitle')} icon="success">
                    <div className="aggregator-psd2-credentials__information">
                        <FormattedText value="aggregatorPSD2-credentialsOkInformation" />
                    </div>
                    <div className="aggregator-psd2-credentials__button-indications">
                        <FormattedText value="aggregatorPSD2-credentialsOkButtonIndication" injectedStrings={[bankName || '']} />
                    </div>
                    <div className="aggregator-psd2-credentials__logo-bank-wrapper">
                        <img className="aggregator-psd2-credentials__logo-bank" src={bankLogo} />
                    </div>
                    <div className="aggregator-psd2-credentials__buttons-wrapper">
                        {this.getContinueButton(isRenewTokenFlow)}
                    </div>
                </OKSectionBox>
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorRenewCredentialsPSD2Ok.propTypes = {
    history: PropTypes.object.isRequired,
}
export default withRouter(AggregatorRenewCredentialsPSD2Ok)
